export default __webpack_public_path__ + "static/media/1.9ea2b90f.png";